import React, { useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import BottomNav from "./BottomNav";
import TopBar from "./TopBar";
import { TokenProvider } from "./TokenContext";
import RewardOverlay from "./RewardOverlay";
import { useT } from "../context/LanguageContext";

/**
 * Mobile-first shell for the v2 redesign.
 * - Fills the viewport (no max-width on mobile).
 * - On wide screens, centers a 480px column with dark gutters.
 * - Forces dark theme regardless of global preference.
 * - Hides the legacy global Navbar / .App padding via portal-style absolute positioning.
 */
export default function MobileShell() {
  const { t, lang } = useT();
  useEffect(() => {
    document.documentElement.classList.add("dark");
    document.body.classList.add("v2-active");
    return () => { document.body.classList.remove("v2-active"); };
  }, []);

  return (
    <TokenProvider>
      <div className="fixed inset-0 z-40 bg-[#070710] text-white overflow-hidden font-sans" data-testid="v2-shell" data-lang={lang}>
        {/* Desktop gutters — visual chrome on wide screens. */}
        <div className="hidden md:flex absolute inset-0 items-center justify-center pointer-events-none">
          <div className="text-[#3F3F46] font-mono text-[10px] uppercase tracking-[0.3em] absolute left-8 top-8">{t("v2.shell.preview")}</div>
          <div className="text-[#3F3F46] font-mono text-[10px] uppercase tracking-[0.3em] absolute right-8 bottom-8">{t("v2.shell.phase")}</div>
        </div>

        {/* Phone-shaped column */}
        <div className="relative mx-auto h-full w-full max-w-[480px] flex flex-col bg-[#070710] border-x border-[#1F1F2A]">
          <TopBar />
          <main className="flex-1 overflow-y-auto pb-24 [-webkit-overflow-scrolling:touch]" data-testid="v2-main">
            <Outlet />
          </main>
          <BottomNav />
        </div>

        {/* Tiny escape hatch back to the legacy v1 design */}
        <Link
          to="/"
          data-testid="v2-back-to-v1"
          className="hidden md:flex absolute top-8 right-8 items-center gap-2 text-[#71717A] hover:text-white text-xs font-mono uppercase tracking-[0.2em]"
        >
          {t("v2.nav.back2v1")}
        </Link>

        {/* Reward overlay (renders only when TokenContext detects new tokens) */}
        <RewardOverlay />
      </div>
    </TokenProvider>
  );
}
